module.exports = __webpack_public_path__ + "static/media/micro375.519f8ffa.jpg";